var map = {
	"./demo/patient/": [
		25670,
		670
	],
	"./quinsair/patient/": [
		10902,
		902
	],
	"./rybelsus/patient/": [
		64839,
		839
	],
	"./sephience/patient/": [
		48249,
		249
	],
	"./trikafta-12/patient/": [
		62365,
		365
	],
	"./trikafta-6-11/patient/": [
		51035,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 17110;
module.exports = webpackAsyncContext;